@if (currentItemData(); as data) {
	<div class="tabDivider">{{ currentGroupIndex() + 1 }}. {{ data.group.name }}</div>

	<div class="groupCard">
		<sim-assessment-item
			[@zoomInOnEnter]
			[@zoomOutOnLeave]
			class="item"
			[hideScore]="true"
			[hideExpandButton]="true"
			[hideExpansionArea]="true"
			[data]="currentItemAssessmentData()"
		/>

		<sim-button
			(onClick)="moveToNextItem()"
			[disabled]="isNextItemButtonDisabled()"
			[label]="T.ASSESSMENT_SINGLE_ITEM_ANSWER_PANEL_SAVE_AND_CONTINUE"
			color="accent"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
		/>
	</div>

	<p class="hint">
		{{ T.ASSESSMENT_SINGLE_ITEM_ANSWER_PANEL_HINT | translate }}
	</p>
}
